import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import isEmpty from "lodash-es/isEmpty";

import SETTINGS from "../settings.json";

import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";

import Link from "@mui/material/Link";
import Snowfall from "react-snowfall";
import { GoogleLogin } from "@react-oauth/google";

import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";

import { ReactComponent as WindowIcon } from "../icons/Window24.svg";

import { doService } from "../services/ServiceHelper";

import {
  validateGoogle,
  reValidateGoogle,
  validateMS,
  getUserPriority,
  updateDetails,
  checkinLogin,
  getUserRegions,
  getEmailFromJwt,
  getUserEid,
  savePushTokenForCurrentUser
} from "../services/UserService";
import { useNavigate } from "react-router-dom";
import {
  useJwtStorage,
  useLocalStorage,
} from "../hooks/useLocalStorage";
import { logoutUser } from "../services/UserService";
import { googleLogout } from "@react-oauth/google";

import ProgressBar from "../components/ProgressBar";
import { getMonthNum, getYYYYMMDD } from "../services/DateService";
import {
  createPass,
  decryptLeavePass,
  decryptReturnPass,
  returnQrPass,
  PASS_QR_KEY,
} from "../services/PassService";
import { doTardyQrScore } from "../services/ScoreService";

import { getSubDomain, isSubDomainKnown } from "../services/StringService";
import {
  showError,
  showSuccess,
  showSuccessHtml,
  showOptions,
  showHtml,
} from "../components/ATPDialogs";
import {
  getFirstSchool,
  getSchoolBySubdomain,
  getSchoolByEid,
  getEmptySchool,
} from "../services/SchoolService";
import { SCORE_QR_KEY, decryptTardy } from "../services/ScoreService";
import {
  ACTIVITY_QR_KEY,
  decryptActivitySignup,
  getActivityDateDetails,
  decryptActivityAttend,
  doSingleSignup,
  doSingleSignupAttend,
  doAttend,
  getActivityDateByEidTime,
} from "../services/ActivityService";
import Stack from "@mui/material/Stack";
import dayjs from "dayjs";
import { getKy } from "../services/AbstractService";

const msClientId = "3c720def-7fa2-43f9-9c16-0a48c33bd850";
const GOOGLE_WEB_CLIENT_ID =
  "55954634468-jp58t37klj69rr0l1vljnsmmg6d0pltm.apps.googleusercontent.com";
let _msalInstancePromise = null;
let pushRegistrationListener = null;
let pushRegistrationErrorListener = null;

const msalConfiguration = {
  auth: {
    clientId: msClientId,
    authority: `https://login.microsoftonline.com/common/`,
  },
};

const Login = ({ qrType = null, qrCode = null, checkin = "false" }) => {
  const [_school, setSchool] = useLocalStorage(
    "Auth",
    "school",
    getEmptySchool(),
  );
  const [, setUser] = useLocalStorage("Auth", "user", {});
  const [, setJwt] = useJwtStorage();
  const [, setGoogleJwt] = useLocalStorage("Auth", "gjwt", null);
  const [, setProductName] = useLocalStorage(
    "Auth",
    "productName",
    "AllTimely+",
  );
  const [, setProductSource] = useLocalStorage("Auth", "productSource", "");

  const [ad] = useLocalStorage("Auth", "ad", null);
  const [asd, setAsd] = useLocalStorage("Auth", "asd", null);
  const [af] = useLocalStorage("Auth", "af", null);
  const [asf] = useLocalStorage("Auth", "asf", null);
  const [showProgress, setShowProgress] = useState(false);

  const [_checkinUserType, setCheckinUserType] = useState("S");
  const [_checkinStudentId, setCheckinStudentId] = useState("");
  const [_showPassword, setShowPassword] = React.useState(false);

  const [isWinter, setWinter] = useState(false);
  const [isFall, setFall] = useState(false);

  const leaf1 = document.createElement("img");
  leaf1.src = "./image/maple-leaf.png";
  leaf1.width = 44;
  leaf1.height = 44;
  const leaf2 = document.createElement("img");
  leaf2.src = "./image/leaves.png";
  leaf2.width = 52;
  leaf2.height = 52;
  const images = [leaf1, leaf2];

  const navigate = useNavigate();
  const params = useParams();

  let _hasInit = false;

  useEffect(() => {
    const subdomain = getSubDomain();
    console.log("subdomain: " + subdomain);
    const school = getSchoolBySubdomain(subdomain);

    checkVersion();

    if (!_hasInit) {
      sessionStorage.setItem("ATP.version", SETTINGS.version);
      _hasInit = true;
      if (school != null) {
        setSchool(school);
      } else {
        // for localhost and plus.alltimely.com
        setSchool(getEmptySchool());
      }

      // 5 minutes
      // 300000
      setInterval(checkVersion, 300000);
    }

    // set december
    const month = getMonthNum();
    setWinter(month === 12 || month === 1 || month === 2);
    setFall(month === 10 || month === 11);
  }, [params]);

  async function checkVersion() {
    getKy(null)
      .get("data/settings.json")
      .json()
      .then((response) => {
        const currentVersion = sessionStorage.getItem("ATP.version");
        if (currentVersion != null) {
          if (currentVersion !== response.version) {
            window.location.reload();
            console.log("CLICK OK TO UPGRADE");
          }
        }
      });
  }

  const myStyle = {
    backgroundImage: "url('image/bg2.jpg')",
    minHeight: "100vh",
    backgroundSize: "cover",
    display: "flex",
    flexDirection: "column",
  };

  const isGoogleSchool = () => {
    if (_school == null) return false;
    return _school["at"] == null || _school["at"] === "G" || _school["at"] === "GM";
  };

  const isMicrosoftSchool = () => {
    if (_school == null) return false;
    return _school["at"] === "M" || _school["at"] === "GM";
  };

  const getMsalInstance = async () => {
    if (!_msalInstancePromise) {
      _msalInstancePromise = import("@azure/msal-browser").then(
        ({ PublicClientApplication }) =>
          new PublicClientApplication(msalConfiguration),
      );
    }
    return _msalInstancePromise;
  };

  const handleSigninMicrosoft = async () => {
    const msalInstance = await getMsalInstance();
    await msalInstance.initialize();

    let loginResponse = null;
    try {
      loginResponse = await msalInstance.loginPopup({});
    } catch (err) {
      // handle error
      console.log("ERR");
      console.log(err);
      showError("Unable to sign in user (MS): ", err);
      return;
    }

    setShowProgress(true);
    console.log(loginResponse);

    let school = _school;

    // if the school region is empty - does not have a URL then we need to pull
    // regions; this is typically used if the domain is localhost or app.alltimely.com
    if (school.region == null) {
      const email = loginResponse.account.username;
      doGetUserRegionMS(school, loginResponse, email);
    } else {
      doValidateMS(school, loginResponse);
    }
    doValidateMS(school, loginResponse);
  };

  const doGetUserRegionMS = (school, loginResponse, email) => {
    getUserRegions(email).then(async (results) => {
      const entries = results.data;
      if (entries == null || entries.length === 0) {
        showError(
          "Unable to Log In",
          "User does not exist in AllTimely (Region).",
        );
        return;
      }

      // if user does have an entry, then count up the number of regions it belogs to
      const entry = entries[0];
      const regions = entry.user_regions;

      if (regions.length === 1) {
        // assign the region to the empty school to get the ball rolling
        school.region = regions[0];
      } else {
        // more than 1 region, prompt user for which region, populate, then continue
        const regionResult = await showOptions(
          "Select a Region",
          "Click Region Name",
          getRegionsOptions(regions),
        );
        if (!regionResult.isConfirmed) {
          return;
        }
        school.region = regionResult.value;
      }
      doValidateMS(school, loginResponse);
    });
  };

  const doValidateMS = (inputSchool, loginResponse) => {
    validateMS(inputSchool, loginResponse.idToken)
      .then((result) => {
        if (result.detail) {
          showError(
            "Unable to Log In",
            `User ${loginResponse.account.username} does not exist in AllTimely.`,
          );
          return;
        }

        // pull the actual school and set it
        let school = getSchoolByEid(result.data.schools[0].schoolEid);
        setSchool(school);

        const user = result.data.user;
        const jwt = result.data.jwt;
        // NEVER DELETE - USED FOR ANDROID
        console.log(
          "NXT:" + SETTINGS.version + "|" + jwt + "|" + school.lambdaEndpoint,
        );

        postLogin(school, jwt, user);
      })
      .catch((error) => {
        console.log(error);
        window.showSnack("Unable to validate user (MS).  Please login again.");
      })
      .finally(() => {
        setShowProgress(false);
      });
  };

  const postLogin = (school, jwt, user) => {
    // wait for school settings to apply
    setTimeout(function () {
      // console.log("sleep 100");
      setUser(user);
      setJwt(jwt);

      if (school != null) {
        setProductName(school.title);
      } else {
        setProductName("AllTimely+");
      }
      setProductSource("self");
      evalFcmToken(school, jwt);
      evalNotificationRegistration(school, jwt);
      evalWelcome(school, jwt);
    }, 100);
  };

  const postCheckin = (school, jwt) => {
    // wait for school settings to apply
    setTimeout(function () {
      // console.log("sleep 100");
      setJwt(jwt);
      if (school != null) {
        setProductName(school.title);
      } else {
        setProductName("AllTimely+");
      }
      setProductSource("self");
      navigate("/student/checkin/welcome");
    }, 100);
  };

  /**
   * sees if an fcm token was passed from the apple phone app; if so, then pass on to server for processing
   */
  const evalFcmToken = (school, jwt) => {
    // we have an fcmToken - send it to the server on successful login
    if (params != null && params["fcmTokenHex"] != null) {
      // sendFcm(school, jwt, getMobileOperatingSystem(), params.fcmTokenHex);
    }
  };

  const getSchoolsOptions = (schools) => {
    const map = {};
    for (let school of schools) {
      map[school.schoolEid] = school.schoolName;
    }
    return map;
  };

  const getRegionsOptions = (regions) => {
    const map = {};
    for (let region of regions) {
      map[region] = region;
    }
    return map;
  };

  const handleValidateGoogle = (response) => {
    const googleJwt = response.credential;
    setShowProgress(true);
    setGoogleJwt(googleJwt);
    console.log(response);
    console.log(response.access_token);

    let school = _school;
    if (_school == null) {
      // get first school (for URL) and set it
      school = getFirstSchool();
      setSchool(school);
    }

    // if the school region is empty - does not have a URL then we need to pull
    // regions; this is typically used if the domain is localhost or app.alltimely.com
    if (school.region == null) {
      const email = getEmailFromJwt(googleJwt);
      doGetUserRegionsGoogle(school, googleJwt, email);
    } else {
      doValidateGoogle(school, googleJwt);
    }
  };

  const isNativeCapacitor =
    typeof window !== "undefined" && !!window.Capacitor?.isNativePlatform?.();

  const isNativeGoogleSigninAvailable = () => {
    return (
      typeof window !== "undefined" && !!window.Capacitor?.isNativePlatform?.()
    );
  };

  const waitForNativeAuthBridge = async (timeoutMs = 6000) => {
    const startedAt = Date.now();

    while (Date.now() - startedAt < timeoutMs) {
      if (typeof window.AllTimelyAuthBridge?.signInWithGoogle === "function") {
        return window.AllTimelyAuthBridge;
      }

      await new Promise((resolve) => setTimeout(resolve, 150));
    }

    return null;
  };

  const handleNativeGoogleSignin = async () => {
    try {
      const authBridge = await waitForNativeAuthBridge();
      if (!authBridge || typeof authBridge.signInWithGoogle !== "function") {
        showError(
          "Unable to Log In",
          "Native Google Sign-In bridge was not ready. Please close and reopen the app.",
        );
        setShowProgress(false);
        return;
      }

      setShowProgress(true);

      const googleJwt = await authBridge.signInWithGoogle({
        // Native Google Sign-In must request ID token with the web/server OAuth client ID.
        clientId: GOOGLE_WEB_CLIENT_ID,
      });

      if (isEmpty(googleJwt)) {
        throw new Error("Native Google Sign-In returned no idToken");
      }

      handleValidateGoogle({ credential: googleJwt });
    } catch (error) {
      console.log(error);
      setShowProgress(false);
      showError(
        "Unable to Log In",
        error?.message || "Google sign-in failed. Please try again.",
      );
    }
  };

  const renderGoogleSignInControl = ({
    autoSelect = false,
    type = "standard",
    width = 300,
    fullWidth = false,
  } = {}) => {
    if (isNativeGoogleSigninAvailable()) {
      return (
        <Button
          sx={{ mt: 1 }}
          variant="contained"
          onClick={handleNativeGoogleSignin}
          fullWidth={fullWidth}
        >
          GOOGLE LOGIN
        </Button>
      );
    }

    return (
      <GoogleLogin
        onSuccess={(credentialResponse) => {
          handleValidateGoogle(credentialResponse);
        }}
        onError={() => {
          console.log("Login Failed");
        }}
        auto_select={autoSelect}
        size="large"
        logo_alignment="left"
        type={type}
        theme="filled_blue"
        width={width}
        fullWidth={fullWidth}
      />
    );
  };

  const doGetUserRegionsGoogle = (school, googleJwt, email) => {
    getUserRegions(email).then(async (results) => {
      const entries = results.data;
      if (entries == null || entries.length === 0) {
        showError(
          "Unable to Log In",
          "User does not exist in AllTimely (Region).",
        );
        return;
      }

      // if user does have an entry, then count up the number of regions it belogs to
      const entry = entries[0];
      const regions = entry.user_regions;

      if (regions.length === 1) {
        // assign the region to the empty school to get the ball rolling
        school.region = regions[0];
      } else {
        // more than 1 region, prompt user for which region, populate, then continue
        const regionResult = await showOptions(
          "Select a Region",
          "Click Region Name",
          getRegionsOptions(regions),
        );
        if (!regionResult.isConfirmed) {
          return;
        }
        school.region = regionResult.value;
      }
      doValidateGoogle(school, googleJwt);
    });
  };

  const doValidateGoogle = (school, googleJwt) => {
    validateGoogle(school, googleJwt)
      .then(async (result) => {
        if (result.detail) {
          showError("Unable to Log In", "User does not exist in AllTimely.");
          return;
        }

        // see list of schools; assign school
        const schools = result.data.schools;
        const jwt = result.data.jwt;
        const user = result.data.user;

        if (schools.length === 1) {
          // get first/only school and set it for student
          school = getSchoolByEid(result.data.schools[0].schoolEid);
          setSchool(school);
          doPostLogin(school, jwt, user);
        } else {
          // this is only if a user has multiple schools attached to them
          // pick a school, regenerate jwt, then continue
          const schoolResult = await showOptions(
            "Select a School",
            "Click School Name",
            getSchoolsOptions(schools),
          );
          if (!schoolResult.isConfirmed) {
            return;
          }

          reValidateGoogle(school, googleJwt, schoolResult.value).then(
            (reValidateResult) => {
              const jwt = reValidateResult.data.jwt;
              // reset the school to the selected value
              school = getSchoolByEid(schoolResult.value);
              setSchool(school);
              doPostLogin(school, jwt, user);
            },
          );
        }
      })
      .catch((error) => {
        console.log(error);
        showError("Unable to validate user.  Please login again.");
      })
      .finally(() => {
        setShowProgress(false);
      });
  };

  // Evaluate post-login actions, including push notification registration for native platforms.
  const evalNotificationRegistration = async (school, jwt) => {
    if (!window.Capacitor?.isNativePlatform?.()) return;
    const push = window.Capacitor.Plugins?.PushNotifications;
    if (!push) {
      console.warn("Capacitor PushNotifications plugin is unavailable");
      return;
    }

    const platform = window.Capacitor.getPlatform(); // "ios" or "android"

    try {
    const deviceId =
      (await window.Capacitor.Plugins.Device.getId()).identifier;

      await pushRegistrationListener?.remove();
      await pushRegistrationErrorListener?.remove();

      // called once for the yes or no
      pushRegistrationListener = await push.addListener("registration", ({ value }) => {
        // On iOS, value is the APNs token.
        savePushTokenForCurrentUser(school, jwt, deviceId, platform, value).catch(
          (error) => console.error("Unable to save push token", error),
        );
      });

      pushRegistrationErrorListener = await push.addListener("registrationError", (error) => {
        console.error("Push registration failed", error);
      });

      let permission = await push.checkPermissions();
      if (permission.receive === "prompt") {
        permission = await push.requestPermissions();
      }
      if (permission.receive === "granted") {
        await push.register();
      } else {
        console.warn("Push notification permission was not granted");
      }
    } catch (error) {
      console.error("Unable to register for push notifications", error);
    }
  };

  const doPostLogin = (school, jwt, user) => {
    // NEVER DELETE - USED FOR ANDROID
    console.log(
      "NXT:" + SETTINGS.version + "|" + jwt + "|" + school.lambdaEndpoint,
    );
    postLogin(school, jwt, user);
  };

  const doPostCheckin = (school, jwt) => {
    postCheckin(school, jwt);
  };

  const evalPassQrReturn = (jwt) => {
    const qrDetails = decryptReturnPass(PASS_QR_KEY, qrCode);

    doService(
      returnQrPass(_school, jwt, qrDetails.userEid, getYYYYMMDD(), "Y"),
      (results) => {
        showSuccess("Pass Returned", "Your pass has been RETURNED.", () => {
          logoutUser();
          googleLogout();
          navigate("/");
        });
        return;
      },
      (detail) => {
        showError("Unable to Return Pass", detail, () => {
          logoutUser();
          googleLogout();
          navigate("/");
        });
        return;
      },
    );
  };

  const evalScoreTardyQr = (jwt) => {
    const qrDetails = decryptTardy(SCORE_QR_KEY, qrCode);

    doService(
      doTardyQrScore(_school, jwt, qrDetails.teacherEid, qrDetails.categoryId),
      (results) => {
        const student = results.data.student;
        const score = results.data.score;

        const html = `
          <table style="margin-left:auto;margin-right:auto">
            <tbody>
              <tr>
                <td style="font-weight:bold;text-align:right">Student:</td>
                <td style="text-align:left">${student.first_name} ${
                  student.last_name
                } (${student.grade})</td>
              </tr>
              <tr>
                <td style="font-weight:bold;text-align:right;font-size:20px">Created On:</td>
                <td style="text-align:left">${dayjs(score.dt).format(
                  "MM/DD/YY hh:mm a",
                )}</td>
              </tr>
              <tr>
                <td style="font-weight:bold;text-align:right">Score Type:</td>
                <td style="text-align:left">${score.category_name}</td>
              </tr>
              <tr>
                <td style="font-weight:bold;text-align:right">Consequence:</td>
                <td style="text-align:left">${score.consequence_name}</td>
              </tr>
            </tbody>
          </table>
          
        `;

        showSuccessHtml(`Tardy QR Processed`, html, () => {
          logoutUser();
          googleLogout();
          navigate("/");
        });
        return;
      },
      (detail) => {
        showError("Unable to Use Tardy QR", detail, () => {
          logoutUser();
          googleLogout();
          navigate("/");
        });
        return;
      },
    );
  };

  const evalActivitySignupQr = (jwt) => {
    const activityDateEid = decryptActivitySignup(ACTIVITY_QR_KEY, qrCode);

    doService(
      getActivityDateDetails(_school, jwt, activityDateEid),
      (results) => {
        // sign up the student
        const activityDate = results.data;

        if (activityDate.period == null) {
          showError("Unable to Add Activity", "Activity has been deleted.");
          return;
        }

        if (activityDate.isMaxxedOut) {
          showError(
            "Unable to Add Activity",
            "Activity " + activityDate.name + " is Maxxed Out.",
          );
          return;
        }

        // try to sign up
        doSingleSignup(_school, jwt, activityDateEid).then((results) => {
          if (results.detail != null) {
            showError("Unable to Add Activity", results.detail);
            return;
          }

          const lastName = results.data.last_name;
          const firstName = results.data.first_name;

          showSuccess(
            "Activity Added!",
            `${lastName}, ${firstName} has been added to the activity.`,
            () => {
              logoutUser();
              googleLogout();
              navigate("/");
            },
          );
        });
      },
      (error) => {
        showError("Unable to Use Activity QR", error, () => {
          logoutUser();
          googleLogout();
          navigate("/");
        });
        return;
      },
    );
  };

  const evalActivitySignupAttendQr = (jwt) => {
    const activityDateEid = decryptActivitySignup(ACTIVITY_QR_KEY, qrCode);

    doService(
      getActivityDateDetails(_school, jwt, activityDateEid),
      (results) => {
        // sign up the student
        const activityDate = results.data;

        if (activityDate.period == null) {
          showError("Unable to Add Activity", "Activity has been deleted.");
          return;
        }

        // we ignore if maxxed out

        // try to sign up
        doSingleSignupAttend(_school, jwt, activityDateEid).then((results) => {
          if (results.detail != null) {
            showError("Unable to Add Activity", results.detail);
            return;
          }

          const lastName = results.data.last_name;
          const firstName = results.data.first_name;

          showSuccess(
            "Activity Added!",
            `${lastName}, ${firstName} has been added to the activity and marked as present.`,
            () => {
              logoutUser();
              googleLogout();
              navigate("/");
            },
          );
        });
      },
      (error) => {
        showError("Unable to Use Activity QR", error, () => {
          logoutUser();
          googleLogout();
          navigate("/");
        });
        return;
      },
    );
  };

  const evalProcessUserQr = () => {
    navigate(`/user/idqr/process/${qrCode}`);
  };

  const evalActivityDateAttendQr = (jwt) => {
    const activityDateEid = decryptActivityAttend(ACTIVITY_QR_KEY, qrCode);

    doService(
      getActivityDateDetails(_school, jwt, activityDateEid),
      (results) => {
        // sign up the student
        const activityDate = results.data;

        if (activityDate.period == null) {
          showError("Unable to Take Attendance", "Activity has been deleted.");
          return;
        }

        // try to mark as attended
        doAttend(_school, jwt, activityDateEid).then((results) => {
          if (results.detail != null) {
            showError("Unable to Take Attendance", results.detail);
            return;
          }

          const lastName = results.data.last_name;
          const firstName = results.data.first_name;
          const periodLabel = results.data.period_label;
          const activityName = results.data.activity_name;
          const currentDate = results.data.current_date_time;

          showSuccess(
            "Attendance Taken!",
            `${lastName}, ${firstName} has been marked as PRESENT for ${periodLabel}'s ${activityName}, on ${currentDate}.`,
            () => {
              logoutUser();
              googleLogout();
              navigate("/");
            },
          );
        });
      },
      (error) => {
        showError("Unable to Use Activity QR", error, () => {
          logoutUser();
          googleLogout();
          navigate("/");
        });
        return;
      },
    );
  };

  const evalActivityAttendQr = (jwt) => {
    const activityEid = qrCode;

    doService(
      getActivityDateByEidTime(_school, jwt, activityEid),
      (results) => {
        // sign up the student
        const activityDate = results.data;

        if (activityDate.period == null) {
          showError("Unable to Take Attendance", "Activity has been deleted.");
          return;
        }

        // try to mark as attended
        doAttend(_school, jwt, activityDate.eid).then((results) => {
          if (results.detail != null) {
            showError("Unable to Take Attendance", results.detail);
            return;
          }

          const lastName = results.data.last_name;
          const firstName = results.data.first_name;
          const periodLabel = results.data.period_label;
          const activityName = results.data.activity_name;
          const currentDate = results.data.current_date_time;

          showSuccess(
            "Attendance Taken!",
            `${lastName}, ${firstName} has been marked as PRESENT for ${periodLabel}'s ${activityName}, on ${currentDate}.`,
            () => {
              logoutUser();
              googleLogout();
              navigate("/");
            },
          );
        });
      },
      (error) => {
        showError("Unable to Use Activity QR", error, () => {
          logoutUser();
          googleLogout();
          navigate("/");
        });
        return;
      },
    );
  };

  const evalPassQrLeave = (jwt) => {
    const qrDetails = decryptLeavePass(PASS_QR_KEY, qrCode);

    doService(
      createPass(
        _school,
        jwt,
        qrDetails.passTypeEid,
        dayjs().format("YYYY-MM-DD"),
        qrDetails.userEid,
        qrDetails.locationEid,
        null,
        null,
        null,
        null,
        "Y",
      ),
      (results) => {
        const thePass = results.data[0].pass;
        // const thePoint = results.data.points[0];
        // console.log(results.data);
        const theStudent = results.data[0].student;

        let message = `A pass has been created AND APPROVED for ${
          theStudent.first_name
        } ${theStudent.last_name} on ${dayjs(thePass.dateCreated).format(
          "MM/DD hh:mm a",
        )} (${thePass.typeName}).`;

        showSuccess("Pass Created", message, () => {
          logoutUser();
          googleLogout();
          navigate("/");
        });
        return;
      },
      (detail) => {
        showError("Unable to Create Pass", detail, () => {
          logoutUser();
          googleLogout();
          navigate("/");
        });
        return;
      },
    );
  };

  const evalQr = (jwt) => {
    switch (qrType) {
      case "pass.qr.leave":
        evalPassQrLeave(jwt);
        break;
      case "pass.qr.return":
        evalPassQrReturn(jwt);
        break;
      case "score.tardy.qr":
        evalScoreTardyQr(jwt);
        break;
      case "activity.ad.signup.qr":
        evalActivitySignupQr(jwt);
        break;
      case "activity.ad.signup-attend.qr":
        evalActivitySignupAttendQr(jwt);
        break;
      case "activity.ad.attend.qr":
        evalActivityDateAttendQr(jwt);
        break;
      case "activity.attend.qr":
        evalActivityAttendQr(jwt);
        break;
      case "user.process.qr":
        evalProcessUserQr();
        break;
      default:
        return false;
    }
    return true;
  };

  const evalWelcome = (school, jwt) => {
    if (evalQr(jwt)) {
      return;
    }

    const priority = getUserPriority(jwt);
    if (school != null && priority === 800) {
      console.log("here");
      console.log(school);
      // redirect if only comm service
      if (
        school.passEnabled === "N" &&
        school.activitiesEnabled === "N" &&
        school.scoreEnabled === "N" &&
        school.communityServiceEnabled === "Y"
      ) {
        navigate("/adm/comm-service");
        return;
      }
    }

    if (priority === 500) {
      navigate("/student/welcome");
    }
    if (priority === 525) {
      navigate("/volunteer/welcome");
    } else if (priority > 500 && priority <= 800) {
      navigate("/teacher/welcome");
    }
    evalDetails();
  };

  const evalDetails = () => {
    // see if there are captured values
    if (ad != null) {
      // console.log("HAS APPLE DETAILS");

      // apple sent details
      if (asd == null) {
        // console.log("HAS NOT SENT DETAILS");
        sendDetails();
      }
    }

    if (af != null) {
      // console.log("HAS TOKEN");

      // apple sent token
      if (asf == null) {
        // console.log("HAS NOT SENT FCM TOKEN");
        // saveEndpoint();
      }
    }
  };

  const sendDetails = () => {
    // apple details
    const details = ad;
    const values = {
      uniqueId: details.id,
      brand: details.brand,
      phoneModel: details.phoneModel,
      device: details.device,
      product: details.product,
      kernelVersion: details.kernelVersion,
      apiVersion: details.apiVersion,
      platform: details.platform,
    };

    updateDetails(values).then((result) => {
      // if ok then mark as sent
      if (result.data && result.data === "ok") {
        setAsd(true);
      }
    });
  };

  const handleClickHelp = () => {
    showHtml(
      "Here are some tips to log in with Google or Microsoft:",
      `
      <div style="text-align:left">
        <ol>
          <li>Make sure your are using your School's Google or MS account. Do not use your private account (it will not work).</li>
          <li>If you logged into Google with your private account previously (e.g. for Gmail or another app), and that is the only Google login on your browser, you may need to log out of Google (from google.com), and then go back to the AllTimely login page.</li>
          <li>If you use your school account, and get redirected back to the Login page, your account needs to be created by your School Administrator.</li>
        </ol>
      </div>
    `,
    );
  };

  const handleChangeCheckinUserType = (event) => {
    setCheckinUserType(event.target.value);
  };

  const handleChangeStudentId = (event) => {
    setCheckinStudentId(event.target.value);
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleCheckinLogin = () => {
    if (isEmpty(_checkinStudentId)) {
      showError("Unable to Login", "Please Enter Student ID.");
      return;
    }


    checkinLogin(getFirstSchool(), _checkinStudentId).then((result) => {
      if (result.detail) {
        showError(
          "Unable to Log In",
          `Checkin User does not exist in AllTimely.`,
        );
        return;
      }
      const jwt = result.data.jwt;
      const school = getSchoolByEid(result.data.schools[0].schoolEid);
      setSchool(school);
      setJwt(jwt);
      doPostCheckin(school, jwt);
    });
  };

  return (
    <Container maxWidth="lg" sx={myStyle}>
      {isWinter && (
        <Snowfall
          style={{
            position: "fixed",
            width: "100vw",
            height: "100vh",
          }}
        />
      )}
      {isFall && (
        <Snowfall
          style={{
            position: "fixed",
            width: "100vw",
            height: "100vh",
          }}
          radius={[15, 15]}
          images={images}
        />
      )}

      {isNativeCapacitor && (
        <>
          <br />
          <br />
          <br />
        </>
      )}
      <Grid
        container
        spacing={2}
        direction="column"
        wrap="nowrap"
        sx={{ flexGrow: 1, height: "100%", pt: 2 }}
      >
        <Grid item xs={12}>
          {getSubDomain() === "app" && (
            <>
              <img
                src="image/icon-student-46.0.png"
                className="tlm-img-center tlm-logo-img"
                style={{ border: "2px white solid" }}
                alt="site icon"
              />
              <img
                src="image/mobile-logo.png"
                className="tlm-logo-text"
                alt="site icon text"
              />
            </>
          )}
          {getSubDomain() !== "app" && (
            <>
              {isSubDomainKnown() && _school != null && (
                <>
                  <img
                    src={`image/school/${_school.subdomain}/logo-small.png`}
                    className="tlm-img-center tlm-logo-img"
                    alt="site icon"
                  />
                  <h1 className="tlm-label-center">{_school.title}</h1>
                  <h2 className="tlm-label-center">{_school.name}</h2>
                </>
              )}
              {(!isSubDomainKnown() || _school == null) && (
                <>
                  <img
                    src="image/icon-student-46.0.png"
                    className="tlm-img-center tlm-logo-img"
                    style={{ border: "2px white solid" }}
                    alt="site icon"
                  />
                  <img
                    src="image/mobile-logo.png"
                    className="tlm-logo-text"
                    alt="site icon text"
                  />
                </>
              )}
            </>
          )}
        </Grid>
        <Grid item xs={12}>
          <ProgressBar showProgress={showProgress} />
          {qrType === "score.tardy.qr" && (
            <span
              className="bebas-neue-regular"
              style={{ fontSize: "40px", color: "#ffffff" }}
            >
              Tardy QR Login
            </span>
          )}
          {qrType === "pass.qr.leave" && (
            <span
              className="bebas-neue-regular"
              style={{ fontSize: "40px", color: "#ffffff" }}
            >
              Bath QR Login
            </span>
          )}
          {qrType === "pass.qr.return" && (
            <span
              className="bebas-neue-regular"
              style={{ fontSize: "40px", color: "#ffffff" }}
            >
              Return QR Login
            </span>
          )}
          {qrType === "activity.ad.signup.qr" && (
            <span
              className="bebas-neue-regular"
              style={{ fontSize: "40px", color: "#ffffff" }}
            >
              Signup QR Login
            </span>
          )}
          {qrType === "activity.ad.signup-attend.qr" && (
            <span
              className="bebas-neue-regular"
              style={{ fontSize: "40px", color: "#ffffff" }}
            >
              Signup+Attend QR Login
            </span>
          )}
          {qrType === "activity.ad.attend.qr" && (
            <span
              className="bebas-neue-regular"
              style={{ fontSize: "40px", color: "#ffffff" }}
            >
              Date Attend QR Login
            </span>
          )}
          {qrType === "activity.attend.qr" && (
            <span
              className="bebas-neue-regular"
              style={{ fontSize: "40px", color: "#ffffff" }}
            >
              Attend QR Login
            </span>
          )}
          {qrType === "event.signup.qr" && (
            <span
              className="bebas-neue-regular"
              style={{ fontSize: "40px", color: "#ffffff" }}
            >
              Event Signup
            </span>
          )}
          {qrType === "user.process.qr" && (
            <span
              className="bebas-neue-regular"
              style={{ fontSize: "40px", color: "#ffffff" }}
            >
              User QR Scan
            </span>
          )}
        </Grid>
        <Grid item xs={12}>
          <div
            className="tlm-label-center"
            style={
              isNativeCapacitor
                ? { marginTop: 0, marginBottom: "8px" }
                : { marginBottom: "10px" }
            }
          >
            SIGN IN WITH:
          </div>
          {checkin === "true" && (
            <>
              <div
                style={{
                  backgroundColor: "white",
                  paddingLeft: "1em",
                  paddingRight: "1em",
                  paddingTop: "0.5em",
                  paddingBottom: "1em",
                }}
              >
                <InputLabel>Are you a:</InputLabel>
                <Select
                  fullWidth
                  size="small"
                  onChange={handleChangeCheckinUserType}
                  value={_checkinUserType}
                  sx={{ mb: 1 }}
                >
                  <MenuItem key="S" value="S">
                    Student
                  </MenuItem>
                  <MenuItem key="T" value="T">
                    Teacher
                  </MenuItem>
                </Select>

                {_checkinUserType === "S" && (
                  <>
                    <InputLabel>Student ID:</InputLabel>
                    <TextField
                      type="text"
                      fullWidth
                      variant="outlined"
                      size="small"
                      onChange={handleChangeStudentId}
                      placeholder="Enter Student ID"
                      value={_checkinStudentId}
                    />
                    <Button
                      sx={{ mt: 2 }}
                      variant="contained"
                      onClick={handleCheckinLogin}
                      fullWidth
                    >
                      LOG IN
                    </Button>
                  </>
                )}

                {_checkinUserType === "T" && (
                  <>
                    {renderGoogleSignInControl({
                      autoSelect: _school.passThroughEnabled === "Y",
                      type: "standard",
                      width: 300,
                      fullWidth: true,
                    })}
                  </>
                )}
              </div>
            </>
          )}
          {checkin === "false" && (
            <>
              {isSubDomainKnown() && (
                <>
                  {isGoogleSchool() && (
                    <div
                      className="mt-1"
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      {renderGoogleSignInControl({
                        autoSelect: _school.passThroughEnabled === "Y",
                        type: "standard",
                        width: 300,
                        fullWidth: true,
                      })}
                    </div>
                  )}

                  {isMicrosoftSchool() && (
                    <Button
                      sx={{ mt: 2 }}
                      variant="contained"
                      startIcon={<WindowIcon />}
                      onClick={handleSigninMicrosoft}
                    >
                      SIGN IN WITH MICROSOFT
                    </Button>
                  )}
                </>
              )}

              {!isSubDomainKnown() && (
                <>
                  <Stack
                    direction="row"
                    spacing={5}
                    alignItems="center"
                    justifyContent="center"
                    sx={{ mt: 2 }}
                  >
                    {renderGoogleSignInControl({
                      type: "icon",
                      width: 120,
                      fullWidth: false,
                    })}
                    <IconButton
                      aria-label="sign in with microsoft"
                      onClick={handleSigninMicrosoft}
                      style={{
                        backgroundColor: "#1976d2",
                        color: "white",
                      }}
                    >
                      <WindowIcon />
                    </IconButton>
                  </Stack>
                </>
              )}
            </>
          )}
        </Grid>
        <Grid item xs={12}>
          <div className="tlm-label-center" style={{ marginTop: "50px" }}>
            UNABLE TO LOGIN? CLICK{" "}
            <Link
              onClick={handleClickHelp}
              sx={{
                ml: 0.5,
                mr: 0.5,
                color: "#c0c0c0",
                cursor: "pointer",
              }}
            >
              HERE
            </Link>{" "}
            FOR HELP.
          </div>
        </Grid>
        <Grid item xs={12}>
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            justifyContent="center"
          >
            <Link
              href="https://www.alltimely.com/terms.html"
              target="_blank"
              sx={{
                ml: 0.5,
                mr: 0.5,
                color: "#c0c0c0",
              }}
            >
              TERMS OF USE
            </Link>
            <Link
              href="https://www.alltimely.com/privacy.html"
              target="_blank"
              sx={{
                ml: 0.5,
                mr: 0.5,
                color: "#c0c0c0",
              }}
            >
              PRIVACY POLICY
            </Link>
          </Stack>
        </Grid>
        <Grid
          item
          xs={12}
          className="tlm-label-center"
          sx={{ mt: "auto", mb: 3 }}
        >
          <Stack direction="column" spacing={1} sx={{ mt: 0 }}>
            <div>Copyright 2026. The Local Machine, LLC</div>
            <div className="tlm-label-center">www.alltimely.com</div>
          </Stack>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Login;
